export default {
  sidebar: {
    personalAccount: "Personal Account",
    menu: "menu",
    home: "Home",
    services: "Services",
    myRequests: "My Requests",
    callHistory: "My Calls",
    osintSearch: "Time to search",
    help: "Help",
    logout: "Logout",
    logoutConfirmTitle: "Confirmation",
    logoutConfirmMessage: "Are you sure you want to log out?",
    logoutConfirmYes: "Yes",
    logoutConfirmNo: "No",
    helpNotAvailable: "Help section will be available soon",
    language: "Language",
    theme: "Theme",
    lightTheme: "Light",
    darkTheme: "Dark",
    darkThemeLabel: "Dark theme",
    lightThemeLabel: "Light theme",
    call: "Call",
    callOperator: "Call operator",
    videoCall: "Video",
    audioCall: "Audio",
    textChat: "Text",
  },
  login: {
    clientPortal: "Client Portal",
    greeting: "Client Portal",
    description:
      "Manage services, track requests and monitor statuses in a single interface.",
    descriptionTagline: "Fast. Clear. To the point.",
    copyright: "© {year} Client Portal. All rights reserved.",
    welcomeTitle: "Welcome to the",
    welcomeSubtitle: "client portal",
    registerTitle: "Create account",
    verifyTitle: "Email verification",
    noAccount: "No account?",
    createAccount: "Sign up",
    hasAccount: "Already have an account?",
    loginLink: "Sign in",
    noAccess: "No access?",
    contactAdmin: "Contact your administrator",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password",
    firstNamePlaceholder: "First name",
    lastNamePlaceholder: "Last name",
    otpPlaceholder: "Code from email",
    otpHint: "Enter the 6-digit code sent to your email",
    loginButton: "Sign in",
    registerButton: "Sign up",
    verifyButton: "Verify",
    backToLogin: "Back to sign in",
    loginWithGoogle: "Sign in with Google",
    loginWithApple: "Sign in with Apple",
    forgotPassword: "Forgot password?",
    emailError: "Failed to get user email",
    invalidEmail: "Enter a valid email",
    tempLoginSuccess: "Temporary login successful",
    authError: "Authentication error",
    emailNotVerified: "Email not verified. Enter the code from your email",
    emailAlreadyExists: "This email is already registered",
    registerError: "Registration error",
    otpSent: "Verification code sent to your email",
    otpInvalid: "Invalid or expired code",
    oauthError: "External authentication error",
    googleError: "Google sign-in error",
    appleError: "Apple sign-in error",
    forgotTitle: "Reset password",
    forgotPrompt: "Enter your email to receive a code",
    forgotButton: "Send code",
    resetPasswordTitle: "Set new password",
    resetPasswordPrompt: "Enter the code from your email and your new password",
    resetPasswordButton: "Save",
    confirmPasswordPlaceholder: "Repeat password",
    passwordMin6: "At least 6 characters",
    passwordMismatch: "Passwords do not match",
    resendCode: "Resend code",
    codeResent: "Code sent to your email",
    passwordResetSuccess: "Password updated, please log in",
    resetCodeInvalid: "Invalid or expired code",
  },
  validation: {
    fieldRequired: "This field is required",
    invalidCredentials: "Invalid login or password",
    networkError: "Network issue. Check your connection or try again later.",
  },
  chat: {
    howCanIHelp: "How can I help you?",
    interestedInService: "Interested in service: {service}",
    detectingIntent: "Finding matching services...",
    foundForms: "Found {count} services. Choose one:",
    noFormFound:
      "Could not find a matching service. Try describing your task in more detail.",
    noFormsAvailable: "No services are available at the moment.",
    intentError: "Service temporarily unavailable. Please try again later.",
  },
  services: {
    title: "Services",
    newRequest: "New request",
    emptyList: "Service list is empty",
    fields: "{count} fields",
    otherServices: "Other services",
    cancel: "Cancel",
    submit: "Submit",
    fillField: "Please fill in: {field}",
    requestSent: "Request submitted",
    active: "Active",
    inactive: "Inactive",
    stages: {
      initiation: "Request initiation",
      initiationSub: "Choose service, location, passport type.",
      preliminaryCheck: "Preliminary check",
      preliminaryCheckSub: "Completeness/validity/payment check.",
      verification: "Identity verification",
      verificationSub: "Database cross-check, clarifications.",
      closing: "Case closing",
      closingSub: "Confirmation of return/result.",
    },
    visa: {
      stepPurpose: "Purpose",
      stepPurposeDesc: "Visit purpose and dates",
      stepPersonal: "Personal Info",
      stepPersonalDesc: "Name, contacts, citizenship",
      stepPassport: "Passport",
      stepPassportDesc: "Number and expiry date",
      stepTravel: "Stay",
      stepTravelDesc: "Host and address",
      stepDocuments: "Documents",
      stepDocumentsDesc: "Photo, scan, invitation",
      stepReview: "Review",
      stepReviewDesc: "Check before submitting",
      purposeTitle: "Purpose of Visit",
      purposeDesc:
        "Select the purpose of your visit and planned dates of stay.",
      personalTitle: "Applicant Information",
      personalDesc:
        "Fill in your personal details. Fields marked with * are required.",
      passportTitle: "Passport Details",
      passportDesc: "Enter your passport number and expiration date.",
      travelTitle: "Stay Information",
      travelDesc:
        "Enter the host organization and your address during the stay.",
      documentsTitle: "Photo & Documents",
      documentsDesc:
        "Upload your photo, passport scan, and invitation letter (if available).",
      photoRequirements: "Photo Requirements",
      photoRule1: "Size: 35 x 45 mm",
      photoRule2: "Color photo on a light background",
      photoRule3: "Face should occupy 70-80% of the frame",
      photoRule4: "No headwear (except religious)",
      photoRule5: "No tinted glasses",
      photoRule6: "Format: JPEG or PNG, max 5 MB",
      uploadFile: "Upload file",
      uploadError: "File upload failed",
      fileAttached: "File attached",
      reviewTitle: "Review Your Application",
      reviewDesc: "Please review all entered data before submitting.",
      back: "Back",
      next: "Next",
    },
  },
  requests: {
    title: "My Requests",
    newRequest: "New request",
    emptyList: "No requests yet",
    stage: "Stage: {stage}",
    defaultStage: "Filling out request",
    noDescription: "No description",
    details: "Details",
    detailsTitle: "Request details",
    service: "Service:",
    status: "Status:",
    currentStage: "Current stage:",
    summary: "Summary:",
    description: "Description:",
    stageDataEmpty: "Stage data not yet filled",
    cancel: "Cancel",
    submitToCrm: "Submit to CRM",
    servicesEmpty: "Service list is empty",
    statusLabels: {
      new: "New",
      in_progress: "In progress",
      completed: "Completed",
      rejected: "Rejected",
    },
    stageLabels: {
      fill: "Filling out request",
      check: "Data verification",
      process: "In progress",
      done: "Completion",
    },
    stageStates: {
      done: "Done",
      active: "Current",
      pending: "Pending",
    },
    analytics: {
      new: "New",
      inProgress: "In progress",
      completed: "Completed",
      rejected: "Rejected",
      resolutionSpeed: "Resolution speed",
      avgTime: "Average time",
      fastest: "Fastest",
      lastActivity: "Last activity",
      lastResponse: "Last response",
      lastRequest: "Last request",
      byService: "By service",
      noService: "No service",
      days: "{n} days",
      hours: "{n} hours",
    },
    tableColumns: {
      id: "ID",
      service: "Service",
      status: "Status",
      created: "Created",
      actions: "Actions",
    },
  },
  callHistory: {
    title: "My Calls",
    emptyList: "No call history",
    caller: "Caller",
    media: "Media",
    statusLabel: "Status",
    duration: "Duration",
    date: "Date",
    rating: "Rating",
    detailsTitle: "Call Details",
    case: "Case",
    queue: "Queue",
    startTime: "Start",
    endTime: "End",
    talkTime: "Talk time",
    waitTime: "Wait time",
    totalTime: "Total time",
    feedback: "Feedback",
    comment: "Comment",
    operators: "Operators",
    recall: "Call back",
    recallHint:
      "Start a new call with the same media type directly to this operator",
    sec: "sec",
    min: "min",
    mediaTypes: {
      voice: "Voice",
      audio: "Audio",
      video: "Video",
      text: "Text",
    },
    analytics: {
      answered: "Answered",
      missed: "Missed",
      other: "Other",
      metrics: "Metrics",
      totalCalls: "Total calls",
      avgTalkTime: "Avg. talk time",
      avgWaitTime: "Avg. wait time",
      byMedia: "By media type",
    },
  },
  chatForm: {
    fileUploaded: "File uploaded successfully",
    fileUploadedHint: "You can now ask any question about the document content",
    placeholder: "Describe your issue or what service you need",
    tooLong:
      "Your request is too long. Please shorten it. Maximum tokens: {limit}",
    maxTokens: "Maximum tokens: {limit}",
    maxFiles: "You can upload a maximum of {limit} files",
    maxFileSize: "File cannot be larger than {size}",
    attachedFiles: "Attached files: {count}",
  },
  stt: {
    init: "Getting microphone access ...",
    started: "Recording started (press Stop to finish)",
    micError: "Microphone access error",
    uploading: "Uploading audio ...",
    uploadError: "Audio upload error",
    finished: "Audio upload complete",
  },
  search: {
    placeholder: "Search and filter",
    resetFilters: "Reset filters",
    appliedFilters: "Applied filters: {count}",
  },
  audio: {
    pause: "Pause",
    listen: "Listen",
  },
  message: {
    you: "You",
    copy: "Copy",
  },
};
